<template>
  <div class="modal-mask" @click.stop="reject">
    <div class="modal-inner">
      <div class="confirm" @click.stop>
        <div class="confirm__icon">
          <svg class="delete-icon" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.81818 13.6173C5.81818 13.8137 5.65909 13.9665 5.45455 13.9665H4.72727C4.52273 13.9665 4.36364 13.8137 4.36364 13.6173V5.93575C4.36364 5.73935 4.52273 5.58659 4.72727 5.58659H5.45455C5.65909 5.58659 5.81818 5.73935 5.81818 5.93575V13.6173ZM8.72727 13.6173C8.72727 13.8137 8.56818 13.9665 8.36364 13.9665H7.63636C7.43182 13.9665 7.27273 13.8137 7.27273 13.6173V5.93575C7.27273 5.73935 7.43182 5.58659 7.63636 5.58659H8.36364C8.56818 5.58659 8.72727 5.73935 8.72727 5.93575V13.6173ZM11.6364 13.6173C11.6364 13.8137 11.4773 13.9665 11.2727 13.9665H10.5455C10.3409 13.9665 10.1818 13.8137 10.1818 13.6173V5.93575C10.1818 5.73935 10.3409 5.58659 10.5455 5.58659H11.2727C11.4773 5.58659 11.6364 5.73935 11.6364 5.93575V13.6173ZM5.45455 2.79329L6.01136 1.51669C6.04545 1.47304 6.13636 1.40757 6.20455 1.39666H9.80682C9.86364 1.40756 9.96591 1.47304 10 1.51669L10.5455 2.79329H5.45455ZM16 3.14246C16 2.94605 15.8409 2.79329 15.6364 2.79329H12.125L11.3295 0.971118C11.1023 0.436464 10.4205 0 9.81818 0H6.18182C5.57954 0 4.89773 0.436464 4.67045 0.971118L3.875 2.79329H0.363637C0.159091 2.79329 0 2.94605 0 3.14246V3.84079C0 4.0372 0.159091 4.18996 0.363637 4.18996H1.45455V14.5775C1.45455 15.7777 2.27273 16.7598 3.27273 16.7598H12.7273C13.7273 16.7598 14.5455 15.7341 14.5455 14.5339V4.18996H15.6364C15.8409 4.18996 16 4.0372 16 3.84079V3.14246Z"
              fill="currentColor" />
          </svg>
        </div>
        <p class="confirm__text">{{ text }}</p>
        <div class="confirm__button-wrap">
          <div class="confirm__button">
            <AppButton
              title="Да"
              type="second"
              :loading="isSending"
              @click.native="confirm"
            />
          </div>
          <div class="confirm__button">
            <AppButton title="Нет" type="third" @click.native="reject" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'

export default {
  name: 'app-confirmation',
  components: {
    AppButton
  },
  props: {
    text: String,
    isSending: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    },
    reject () {
      this.$emit('reject')
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/system/_vars';
    @import '../../../assets/css/system/_mixins';

    .confirm {
        display: flex;
        flex-flow: column;
        align-items: center;
        width: 100%;
        max-width: 380px;
        padding: 25px 20px 20px 20px;
        border: 1px solid $border_color;
        border-radius: 3px;
        background: $color_main;
        box-shadow: 0 4px 4px rgba(23, 63, 125, 0.25);

        &__icon {
            display: flex;
            justify-content: center;
            align-items: center;
            background: $button_color_second;
            color: $color_main;
            @include size(35px);
            border-radius: 50%;
            margin-bottom: 15px;
        }

        &__text {
            text-align: center;
            color: $font_color_second;
            margin-bottom: 20px;
        }

        &__button-wrap {
            display: flex;
            flex-flow: row wrap;
        }

        &__button {
            margin-right: 15px;
            margin-bottom: 10px;

            .button {
                width: 100px;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
</style>
